import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';

import HomeCard from '../../components/HomeCard';
import { colors } from '../../styles';

const styles = css`
  display: flex;
  flex-direction: column;
  .CommunityHomes {
    padding: 5vh 0;
    h3 {
      font-weight: bold;
      font-size: 22px;
      color: ${colors.brand1};
      margin-bottom: 20px;
      text-align: center;
      font-weight: 500;
      @media(min-width: 992px) {
        font-size: 33px;
        letter-spacing: 1px;
        font-size: 45px;
        padding: 20px 0;
      }
    }
  }
  .CommunityHomes_list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .CommunityHomes_item {
      width: 361px;
      min-height: 635px;
      height: auto;
      margin: 10px;
      @media(min-width: 768px) {
        height: 635px;
        min-width: unset;
      }
    }
  }

  .ButtonDefault {
    min-width: 272px;
    cursor: pointer;
    margin: 30px auto 0;
  }
`;

class CommunityDetailHomes extends React.Component {
  constructor(props) {
    super(props);

    const increment = 8;
    this.state = {
      increment,
      limit: increment,
    };

    this.showMore = this.showMore.bind(this);
  }

  showMore() {
    this.setState({
      limit: this.state.limit + Infinity,
    });
  }

  render() {
    const { community, homes } = this.props;
    return (
      <div className={styles}>
        {
          homes.length > 0 &&
          <div className="container">
            <div className="row">
              {
                orderBy(homes, ['moveInDate', 'sqft']).map(home => (
                  <div key={home._id} className="col-lg-4">
                    <HomeCard home={home} community={community} />
                  </div>
                ))
              }
            </div>
            {/* {
              limit < homes.length &&
              <div className="Button_wrapper">
                <button
                  className="btn"
                  onClick={this.showMore}
                >
                  Load All {homes.length} Homes
                </button>
              </div>
            } */}
          </div>
        }
      </div>

    );
  }
}

CommunityDetailHomes.propTypes = {
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  community: true,
  homes: true,
})(CommunityDetailHomes);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Homes.js